























































































import { Component, Vue } from "vue-property-decorator";
import { UtilitiesFunctions } from "@/helpers";
import RouteTranslations from "@/locales/routerTranslations";

@Component
export default class SuccessPayment extends Vue {
  handleRoute = UtilitiesFunctions.handleRoute;
  translations: any = RouteTranslations;
  paymentStatus?: string = "not-found";
  isGift?: boolean = false;
  isInstantBooking?: boolean = false;
  isInquiry?: boolean = false;

  mounted() {
    if (this.$route.query.payment === "ok") this.paymentStatus = "ok";
    if (this.$route.query.payment === "ko") this.paymentStatus = "ko";
    if (this.$route.query.gift) this.isGift = true;
    if (this.$route.query.instantBooking) this.isInstantBooking = true;
    if (this.$route.query.isInquiry) this.isInquiry = true;

    console.log(this.$route.query.isInquiry);


    if (this.paymentStatus === "not-found") this.goToNotFoundPage();
    // console.warn("this.$route.params:", this.$route.query);
  }

  goToNotFoundPage() {
    this.$router.push({ path: "notFoundPage" });
  }
}
